import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, ModalBody, Button, Row, Col, Form, Label, Input } from 'reactstrap';
import { StyledCard } from '../Base/Common/CommonUIComponents';
import OperatorDataSection from '../Base/Common/OperatorDataSection';
import { postAPI } from '../Base/API';
import { handleNotification } from '../Base/Common/Notification';
import ProfileInfoSection from '../Base/Common/ProfileInfoSection';

class AddRechargeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recharge: {
                vouhcerId: this.props.voucherId,
                salePrice: 0,
                hostPaymentCodes: [
                    {
                        hostPaymentCode: null,
                        amount: 0
                    }
                ],
            }
        };
    }

    createRecharge = (e) => {
        e.preventDefault();

        this.setState({ block: true });

        postAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                }
                else if (data.response?.length > 0) {
                    handleNotification(data, <FormattedMessage id="AddRechargeModal.RechargeAddedSuccessfully" />, <FormattedMessage id="generic.success" />);
                    this.props.addRecharge(data.response[0]);
                }

                this.setState({ block: false });
            }
        }, `/api/Voucher/Voucher/v1/voucherRecharge/${this.props.voucherId}`, this.state.recharge);
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState(prevState => ({
            recharge: {
                ...prevState.recharge,
                [name]: value
            }
        }));
    }
    handleSalePriceChange = (e) => {
        const { name, value } = e.target;
        const { recharge } = this.state;

        recharge.salePrice = value; 
        recharge.hostPaymentCodes[0].amount = value;

        this.setState({ recharge });
    }

    handleSelect = (val, evt) => {
        if (evt) {
            let name = evt.name;
            let value = val.value;

            if (name === 'hostUserCode') {
                this.setState(prevState => ({
                    ...prevState,
                    recharge: {
                        ...prevState.recharge,
                        hostUserCashboxCode: null
                    },
                }));
            }

            this.setState(prevState => ({
                ...prevState,
                recharge: {
                    ...prevState.recharge,
                    [name]: value
                },
            }));
        }
    }

    handlePaymentCodeSelect = (val, evt) => {
        if (evt) {
            const { value }= val;
            const { recharge } = this.state;
            recharge.hostPaymentCodes[0].hostPaymentCode = value;

            this.setState({ recharge });
        }
    }

    updateRechargeData = (rechargeData) => {
        this.setState({ recharge: rechargeData });
    }


    render() {
        const { isOpen, toggleModal } = this.props;
        const { recharge } = this.state;

        return (
            <Modal isOpen={isOpen} toggle={toggleModal} className="modal-xl">
                <ModalBody className="modal-xl p-0">
                    <StyledCard title={`AddRechargeModal.AddRecharge`} block={this.state.block} error={this.state.error}>
                        <Form onSubmit={(e) => this.createRecharge(e)}>
                            <Row className="mb-2 align-items-center">
                                <Col className="col-2"><Label><FormattedMessage id="AddRechargeModal.RechargeValue" /></Label></Col>
                                <Col className="col-4">
                                    <Input
                                        type="number"
                                        required
                                        value={recharge.voucherValue ?? ''}
                                        name="voucherValue"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={this.props.intl.formatMessage({ id: 'AddRechargeModal.RechargeValue' })}
                                        min={1}
                                    />
                                </Col>
                                <Col className="text-right">
                                    <Button className="btn-host btn-sm" type="submit">
                                        <i className="fa-solid fa-floppy-disk " />
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mb-2 align-items-center">
                                <Col className="col-2"><Label><FormattedMessage id="generic.salePrice" /></Label></Col>
                                <Col className="col-4">
                                    <Input
                                        type="number"
                                        required
                                        value={recharge.salePrice ?? ''}
                                        name="salePrice"
                                        onChange={(e) => this.handleSalePriceChange(e)}
                                        placeholder={this.props.intl.formatMessage({ id: 'generic.salePrice' })}
                                        min={0}
                                    />
                                </Col>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherOperationDetails.InvoiceReference" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        value={recharge.invoiceReference || ''}
                                        name="invoiceReference"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={this.props.intl.formatMessage({ id: 'VoucherOperationDetails.InvoiceReference' })}
                                        maxLength={999}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-2 align-items-center">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="AddRedeem.Notes" /></Label>
                                </Col>
                                <Col className="col-10">
                                    <Input 
                                        type="textarea" 
                                        placeholder={this.props.intl.formatMessage({ id: 'AddRedeem.Notes' })}
                                        maxLength="200" 
                                        name="note" 
                                        value={recharge.note || ''}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </Col>
                            </Row>

                            
                            {global.registerSalesInPms && recharge.salePrice > 0 ?
                                <div>             
                                    <Row className="mt-4">
                                        <Col>
                                            <h6>
                                                <FormattedMessage id="AddVoucher.ClientInfo" />
                                            </h6>
                                        </Col>
                                    </Row>
                                    <hr className="mb-3 mt-0" />          
                                    <ProfileInfoSection
                                        voucher={recharge}
                                        handleChange={this.handleChange.bind(this)}
                                        handleSelect={this.handleSelect.bind(this)}
                                        updateVoucherData={this.updateRechargeData.bind(this)}
                                        hideTitle={true}
                                        fiscalNumberRequired={true}
                                    />             

                                    <Row className="mt-4">
                                        <Col>
                                            <h6>
                                                <FormattedMessage id="AddVoucher.OperatorData" />
                                            </h6>
                                        </Col>
                                    </Row>
                                    <hr className="mb-3 mt-0" />
                                    <OperatorDataSection
                                        operatorData={{
                                            hostUserCode: recharge.hostUserCode,
                                            hostUserCashboxCode: recharge.hostUserCashboxCode,
                                            hostUserPassword: recharge.hostUserPassword,
                                            HostPaymentCodes: recharge.hostPaymentCodes
                                        }}
                                        handleSelect={this.handleSelect.bind(this)}
                                        handlePaymentCodeSelect={this.handlePaymentCodeSelect.bind(this)}
                                        handleHostUserPass={this.handleChange.bind(this)}
                                        hideTitle={true}
                                    />
                                </div>
                            : ''}
                        </Form>

                    </StyledCard>
                </ModalBody>
            </Modal>
        );
    }
}

export default injectIntl(AddRechargeModal);